import React from 'react';
import Base from './Base'

export class Footer extends Base {
  constructor (props) {
    super(props);
   }

  render() {
      return <div className="nk-footer" style={{ backgroundColor: "#16498a" }}>
                            <div className="container-fluid">
                                <div className="nk-footer-wrap">
                                    <div className="nk-footer-copyright text-white">
                                       تمامی حقوق این سایت متعلق به شرکت سپهر داده پرداز زینو میباشد.
                                    </div>
                                </div>
                            </div>
                        </div>
  }
}
